import React from 'react'
import './modal.css'

export default function Modal({ isOpen, setModalOpen, children, className = '' }) {
  if (isOpen) {
    return (
      <div className='backgruound-style'>
        <div className={`modal-alert${className ? ` ${className}` : ''}`}>
          <div>{children}</div>
        </div>
      </div>
    )
  }

  return null
}



